import startCase from "lodash/startCase";
import uniq from "lodash/uniq";
import { useTranslator } from "@eo-locale/react";
import { useEffect, useState } from "react";

import type { Projects } from "@/types";
import { humanize } from "@/lib";
import SelectFilter from "./select-filter";
import { useAppSelector } from "@/redux/store/hooks";

const YearFilter = ({ projects }: Projects): JSX.Element => {
  const { translate } = useTranslator();
  const { finder } = useAppSelector((state) => state.projects);
  const [selection, setSelection] = useState("");
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { locales, filterByDate } = queryFilter;

  useEffect((): void => {
    setSelection(finder.publishedAt || filterByDate);
  }, [filterByDate, finder]);

  const selectedValue = selection
    ? { value: selection, label: startCase(selection) }
    : null;

  const yearsList: string[] = [];
  projects.map((project) =>
    yearsList.push(humanize(project["publishedAt"], "YYYY"))
  );
  const years = uniq(yearsList);

  const yearValue =
    years &&
    years.map((year) => {
      return {
        value: year,
        label: year
      };
    });

  return (
    <SelectFilter
      options={yearValue}
      label={
        locales["projects.timeStamp.all"] || translate("projectFinder.year")
      }
      type="year"
      selectedValue={selectedValue}
      boxClass="ehq-projectsYearFilterContainer"
    />
  );
};

export default YearFilter;
